import React from 'react';

const FeatureWizardSelectionItem = (props) => {
  return (
    <li className={"wiz-steps__item wiz-steps__item--"
    + props.currentFilterValue.displayText.replace(/ /g,"").toLowerCase()}
        onClick={() => props.setWizardValue(props.currentFilterValue)}>
      <span>{props.currentFilterValue.displayText}</span>
    </li>
  );
};

FeatureWizardSelectionItem.displayName = 'FeatureWizardSelectionItem';

export default FeatureWizardSelectionItem;